export const DEFAULT_MEDIA_CHUNK_BYTES = 2 * 1024 * 1024;

export const DEFAULT_DIRECT_UPLOAD_MAX_BYTES = 2 * 1024 * 1024;
